import Hero from "@/components/site/Hero";
import Packages from "@/components/site/Packages";
import Specialties from "@/components/site/Specialties";
import WhyMedas from "@/components/site/WhyMedas";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";

export default function Home() {
  return (
    <>
      <Hero />
      <Specialties />
      <Packages />
      <WhyMedas />
      <Testimonials limit={3} />
      <Contact />
    </>
  );
}
